import { SafeBaseObject } from "@app/core/models/base-object.models"
import { DateTime } from "luxon"

export class ResAdmDocumentationList extends SafeBaseObject {
    topicID = 0
    topicDesc = ''
    subjectTopicID = 0
    subjectTopicDesc = ''
    documentationContentID = 0
    documentationDesc = ''
    startDate = DateTime.invalid('Empty')
    endDate = DateTime.invalid('Empty')
    isInvoiceDisplay = false
    isReservationDisplay = false
    isWebsiteDisplay = false
    isDocumentationDisplay = false
    notes = ''
    companies = ''
    guestPassportCountryCodes = ''
    destinations = ''
    packages = ''
    packageTypes = ''
    services = ''
    webMarket = ''
    subjectTopicDescLang = ''
    notesLang = ''

    guestsCod: number[] = []
    companiesIDs = ''

    constructor(data: any) {
        super();
        this.updateData(data);
        if (data.Companies) {
            this.companiesIDs = data.Companies.match(/\((\d+)\)/g)   // prende "(2900)", "(2902)", ecc.
                .map((n: any) => n.replace(/[()]/g, ""))      // rimuove le parentesi
                .join(",");
        }
    }
}

export class ResAdmTopic extends SafeBaseObject {
    topicID = 0
    topicDesc = ''
    ordering = 0
    invoice = false
    reservation = false
    webSite = false
    documentation = false
    needCountry = false
    needDuration = false
    notes = ''
    status = 'A'

    constructor(data: any) {
        super();
        this.updateData(data);
    }
}

export interface IResApiGetTopic {
    TopicID?: number,
}

export interface IResApiGetTopicSubjectList {
    SubjectTopicID?: number,
    SubjectTopicDesc?: string,
    TopicID?: number,
    TopicDesc?: string,
    Ordering?: number,
    Notes?: string,
}

export class ResAdmTopicSubjectLookup extends SafeBaseObject {
    subjectTopicID = 0
    subjectTopicDesc = ''

    constructor(data: any) {
        super();
        this.updateData(data);
    }
}

export interface IResApiGetDocumentationList {
    DocumentationContentID?: number,
    DocumentationDesc?: string,
    TopicID?: number,
    TopicDesc?: string,
    SubjectTopicID?: number,
    SubjectTopicDesc?: string,
    StartDate?: DateTime,
    EndDate?: DateTime,
    IsInvoiceDisplay?: string,
    IsReservationDisplay?: string,
    IsWebsiteDisplay?: string,
    IsDocumentationDisplay?: string,
    Notes?: string,
    Companies?: string,
    GuestPassportCountryCodes?: string,
    Destinations?: string,
    Packages?: string,
    PackageTypes?: string,
    PackageID?: number,
    PropertyCod?: string,
    PropertyName?: string,
    PropertyCity?: string,
    PropertyCountry?: string,
    Services?: string,
}

export class ResAdmTopicGuests extends SafeBaseObject {
    guestID = 0
    bkgID = 0
    guestCod = 0
    title = ''
    lastName = ''
    firstName = ''
    middleName = ''
    guestNameDisplay = ''

    constructor(data: any) {
        super();
        this.updateData(data);
    }
}

export class ResAdmTopicPreview extends SafeBaseObject {
    topicID = 0
    topicDesc = ''
    subjectTopicID = 0
    subjectTopicDesc = ''
    notes = ''
    applicableTo = ''

    constructor(data: any) {
        super();
        this.updateData(data);
    }
}